var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAppgalleryStroke = function SvgAppgalleryStroke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.05 3C4.353 3 3 4.352 3 8.05v7.9C3 19.648 4.353 21 8.05 21h7.897C19.645 21 21 19.648 21 15.95v-7.9C21 4.352 19.647 3 15.95 3h-7.9Z",
    stroke: "currentColor",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.852 13.44h.723l-.363-.843-.36.843Zm-.178.425-.214.49h-.488L11.01 12h.421l1.034 2.355h-.5l-.213-.49h-1.078Zm7.855.488H19V12h-.471v2.353Zm-1.878-1.01h.87v-.43h-.87v-.482h1.262v-.43H16.18v2.354h1.78v-.43H16.65v-.583Zm-1.874.277L14.242 12h-.39l-.536 1.62-.52-1.619h-.509l.821 2.355h.396l.536-1.547.536 1.547h.399l.819-2.355h-.496l-.521 1.62ZM9.25 13.35c0 .383-.19.588-.535.588-.348 0-.539-.21-.539-.604v-1.331h-.478v1.347c0 .663.368 1.043 1.01 1.043.648 0 1.02-.388 1.02-1.063V12h-.478v1.349ZM6.558 12h.478v2.357h-.478V13.4h-1.08v.957H5V12h.479v.95h1.08V12ZM9.675 6A2.328 2.328 0 0 0 12 8.325 2.328 2.328 0 0 0 14.325 6h.6A2.928 2.928 0 0 1 12 8.925 2.928 2.928 0 0 1 9.075 6h.6Z",
    fill: "currentColor"
  })));
};

export default SvgAppgalleryStroke;